export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-foreground-900 to-foreground-800 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4">
                移动端随时看
              </h2>
              <p className="text-sm md:text-base text-white/65 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                黑料在线全面适配移动端浏览器，无论是在通勤路上还是午休间隙，打开手机即可享受黑料在线观看体验。高清流畅，随时随地不错过任何一条黑料大瓜。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/10 text-white text-sm font-medium rounded-full border border-white/15 whitespace-nowrap cursor-pointer">
                  <i className="ri-smartphone-line"></i>
                  手机浏览器访问
                </span>
                <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-500 text-white text-sm font-medium rounded-full whitespace-nowrap cursor-pointer">
                  <i className="ri-qr-code-line"></i>
                  扫码直达
                </span>
              </div>
            </div>
            <div className="flex-1 flex justify-center p-6 md:p-8">
              <div className="w-40 h-40 md:w-48 md:h-48 bg-white rounded-2xl flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-qr-code-line text-6xl text-foreground-800"></i>
                  <p className="text-xs text-foreground-400 mt-2">手机扫码访问</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}